import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { withRouter } from 'react-router';
import { Button, ButtonGroup, Col, Row } from 'reactstrap';
import { IDispatchList } from 'src/Interfaces/DispatchInterface';
import { DispatchStore } from 'src/Stores/Dispatch/DispatchStore';
import { MessageStore } from 'src/Stores/Messages/Messages';
import { UserStore } from 'src/Stores/User/UserStore';
import { WellsStore } from 'src/Stores/Wells/WellsStore';
import Dispatch from '../../Dispatch/Dispatch/Dispatch';
import DispatchListTable from '../../Dispatch/DispatchListTable/DispatchListTable';
import WorkflowHeader from '../../WorkflowHeader';

@inject('stores')
@observer
class WellDispatch extends React.Component {
    private DispatchStore: DispatchStore;
    private WellsStore: WellsStore;
    private MessageStore: MessageStore;
    private UserStore: UserStore;
    public props: any;
    public state = {
        statusFilters: [] as any[],
        typeFilters: [] as any[],
    };

    constructor(props: any) {
        super(props);
        this.DispatchStore = this.props.stores.DispatchStore;
        this.UserStore = this.props.stores.UserStore;
        this.MessageStore = this.props.stores.MessageStore;
        this.WellsStore = this.props.stores.WellsStore;
    }

    public componentDidMount() {
        this.WellsStore.getWellDetails(this.props.match.params.wellId);
        this.DispatchStore.getDispatches();
        if (!this.UserStore.user) {
            this.UserStore.getProfile();
        }
    }

    public updateDispatches = () => {
        this.DispatchStore.getDispatches();
    }

    public buttonColor = (listName: string, buttonName: string) => {
        const currList: any[] = this.state[listName];
        if (currList.some(value => value === buttonName)) {
            return 'primary';
        }
        return 'outline-primary';
    }

    public allButtonTypeColor = (listName: string) => {
        if (this.state[listName].length > 0) {
            return 'outline-primary';
        }
        return 'primary';
    }

    public handleFilterBoxClick = (listName:string, filterName: string) => (event: any) => {
        const filterIndex = this.state[listName].findIndex((value: any) => value === filterName);
        let listFilters: any[] = this.state[listName];
        if (filterName === 'all') {
            listFilters = [];
        } else if (filterIndex < 0) {
            listFilters.push(filterName);
        } else {
            listFilters.splice(filterIndex, 1);
        }

        if (listName === 'statusFilters' && listFilters.length === 6) {
            listFilters = [];
        }
        if (listName === 'typeFilters' && listFilters.length === 3) {
            listFilters = [];
        }
        this.setState({[listName]: listFilters});
    }

    private mapShowApproval = (item: IDispatchList) => {
        const hasApproveAll = this.UserStore.hasPermission('Permissions.Dispatch.Approve.All');
        if (hasApproveAll) {
            return true;
        }
        const hasApproveAssigned = this.UserStore.hasPermission('Permissions.Dispatch.Approve.Assigned');
        if (hasApproveAssigned) {
            const sourceWellIds = item.sourceWell && item.sourceWell.engineerIds ? item.sourceWell.engineerIds : [];
            const destWellIds = item.destinationWell && item.destinationWell.engineerIds ? item.destinationWell.engineerIds : [];
            return sourceWellIds.concat(destWellIds).some(id => id === this.UserStore.user.id);
        }
        return false;
    }

    private approveDispatch = (dispatchId: string) => {
        const currDispatch = this.DispatchStore.dispatches.find(d => d.id === dispatchId);
        if (currDispatch) {
            this.DispatchStore.updateDispatchStatus(dispatchId, 
                {
                    comment: '',
                    estimatedArrival: currDispatch.estimatedArrival,
                    id: '',
                    requestedArrival: currDispatch.requestedArrival,
                    status: 'Approved',
                })
                .then(data => {
                    if (data) {
                        this.MessageStore.addMessage('Dispatch Approved.', 'success');
                        this.DispatchStore.getDispatches();
                    }
                });
        }
    }

    private rejectDispatch = (dispatchId: string) => {
        const currDispatch = this.DispatchStore.dispatches.find(d => d.id === dispatchId);
        if (currDispatch) {
            this.DispatchStore.updateDispatchStatus(dispatchId, 
                {
                    comment: '',
                    estimatedArrival: currDispatch.estimatedArrival,
                    id: '',
                    requestedArrival: currDispatch.requestedArrival,
                    status: 'Rejected',
                })
                .then(data => {
                    if (data) {
                        this.MessageStore.addMessage('Dispatch Rejected.', 'success');
                        this.DispatchStore.getDispatches();
                    }
                });
        }
    }

    public filterDispatchList = (item: IDispatchList) => {
        let resultType;
        let resultStatus;
        if (item.sourceWellId !== this.WellsStore.well.id && item.destinationWellId !== this.WellsStore.well.id) {
            return false;
        }

        if (this.state.typeFilters.length === 0) {
            resultType = true;
        } else {

            for (const filterName of this.state.typeFilters)
            {
                const result = item.type.toLowerCase() === filterName;

                if (result) {
                    resultType = true;
                }
            }
        }

        if (this.state.statusFilters.length === 0) {
            resultStatus = true;
        } else {
            for (const filterName of this.state.statusFilters) {

                let result;
                switch(filterName) {
                    case 'approved':
                        result = item.dispatchStatus === 'Approved';
                        break;
                    case 'submitted':
                        result = item.dispatchStatus === 'Submitted';
                        break;
                    case 'updated':
                        result = item.dispatchStatus === 'Updated';
                        break;
                    case 'confirmed':
                        result = item.dispatchStatus === 'Confirmed';
                        break;
                    case 'received':
                        result = item.dispatchStatus === 'Received';
                        break;
                    case 'rejected':
                        result = item.dispatchStatus === 'Rejected';
                        break;
                    case 'completed':
                        result = item.dispatchStatus === 'Completed';
                        break;
                    case 'denied':
                        result = item.dispatchStatus === 'Denied';
                        break;
                }
                if (result) {
                    resultStatus = true;
                }
            }
        }

        if (resultType && resultStatus) {
            return true;
        }
        return false;
    }

    public render() {
        if (!this.DispatchStore.dispatches || !this.UserStore.user || !this.WellsStore.well) {
            return this.props.workflowHeaderItems && <WorkflowHeader workflowHeaderItems={this.props.workflowHeaderItems} />;
        }
        return (
            <div>
                { this.props.workflowHeaderItems && <WorkflowHeader workflowHeaderItems={this.props.workflowHeaderItems} />}
                <Row>
                    <Col>
                        <h4 style={{fontSize: '2.4rem'}}>Well Dispatches</h4>
                    </Col>
                </Row>
                <Row style={{marginBottom: '1vh'}}>
                    <Col>
                        <h3>Filter by Type:</h3>
                        <Button type='button' color={this.allButtonTypeColor('typeFilters')} onClick={this.handleFilterBoxClick('typeFilters', 'all')}>All</Button>
                        {' '}
                        <ButtonGroup>
                            <Button type='button' color={this.buttonColor('typeFilters', 'transfer')} onClick={this.handleFilterBoxClick('typeFilters', 'transfer')}>Transfer</Button>
                            <Button type='button' color={this.buttonColor('typeFilters', 'delivery')} onClick={this.handleFilterBoxClick('typeFilters', 'delivery')}>Delivery</Button>
                            <Button type='button' color={this.buttonColor('typeFilters', 'pickup')} onClick={this.handleFilterBoxClick('typeFilters', 'pickup')}>Pickup</Button>
                        </ButtonGroup>
                    </Col>
                    <Col>
                        <h3>Filter by Status:</h3>
                        <Button type='button' color={this.allButtonTypeColor('statusFilters')} onClick={this.handleFilterBoxClick('statusFilters', 'all')}>All</Button>
                        {' '}
                        <ButtonGroup>
                            <Button type='button' color={this.buttonColor('statusFilters', 'submitted')} onClick={this.handleFilterBoxClick('statusFilters', 'submitted')}>Submitted</Button>
                            <Button type='button' color={this.buttonColor('statusFilters', 'approved')} onClick={this.handleFilterBoxClick('statusFilters', 'approved')}>Approved</Button>
                            <Button type='button' color={this.buttonColor('statusFilters', 'rejected')} onClick={this.handleFilterBoxClick('statusFilters', 'rejected')}>Rejected</Button>
                            <Button type='button' color={this.buttonColor('statusFilters', 'confirmed')} onClick={this.handleFilterBoxClick('statusFilters', 'confirmed')}>Confirmed</Button>
                            <Button type='button' color={this.buttonColor('statusFilters', 'denied')} onClick={this.handleFilterBoxClick('statusFilters', 'denied')}>Denied</Button>
                            <Button type='button' color={this.buttonColor('statusFilters', 'completed')} onClick={this.handleFilterBoxClick('statusFilters', 'completed')}>Completed</Button>
                        </ButtonGroup>
                    
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <DispatchListTable 
                            dispatchList={this.DispatchStore.dispatches.filter(this.filterDispatchList)}
                            showApprovalColumn={this.DispatchStore.dispatches.filter(this.filterDispatchList).map(this.mapShowApproval)}
                            onApprove={this.approveDispatch}
                            onReject={this.rejectDispatch}
                        />
                    </Col>
                </Row>
                <Dispatch forWell={this.WellsStore.well.id} />
            </div>
        );
    }
}

export default withRouter(WellDispatch);


// WEBPACK FOOTER //
// ./src/Components/Main/WellWorkflow/WellDispatch/WellDispatch.tsx